import { render } from "./PasskeyIcon.vue?vue&type=template&id=ef296222&scoped=true"
import script from "./PasskeyIcon.vue?vue&type=script&lang=js"
export * from "./PasskeyIcon.vue?vue&type=script&lang=js"

import "./PasskeyIcon.vue?vue&type=style&index=0&id=ef296222&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef296222"]])

export default __exports__